
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import { DIETS_LIST } from '@/utils/constants';
import IconButton from '@/components/shared/suites/IconButton.vue';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import ChipContainer from '@/components/shared/ChipContainer.vue';

@Component<StaffOrderingFilter>({
	components: {
		IconButton,
		StandardModal,
		ChipContainer
	}
})
export default class StaffOrderingFilter extends Vue {
	@Prop({ type: String, required: true }) private id!: string;
	@Prop({ type: Array, default: () => [] }) private availableDiets!: string[];
	@Prop({ type: Array, default: () => [] }) private value!: string[];

	private showModal: boolean = false;
	private draftDiets: string[] = [];

	private get dietList(): { label: TranslateResult; value: string }[] {
		return DIETS_LIST.filter((diet: { label: TranslateResult; value: string }) => this.availableDiets.includes(diet.value));
	}

	private get applyLabel(): string {
		const base = this.$t('shared.actions_array.btn_apply');
		return this.draftDiets.length ? `${base} (${this.draftDiets.length})` : `${base}`;
	}

	private openModal(): void {
		this.draftDiets = [...this.value];
		this.showModal = true;
	}

	private apply(): void {
		this.$emit('input', [...this.draftDiets]);
		this.showModal = false;
	}

	private discard(): void {
		this.draftDiets = [];
		this.$emit('input', []);
		this.showModal = false;
	}
}
